import React from 'react';
import { instaLink, linkedinLink, title } from '../Config/Config';
import { Link } from 'react-router-dom';
import { TopItem } from '../AllContent/Content';
import { OpenInNew } from '@mui/icons-material';
import Loader from '../Config/Loader';

const PreviewTools = () => {
    return (
        <>
            <Loader timer={100} />
            <div className='__tools'>
                <div className='__common-head'>
                    <div className='__container'>
                        <h2>Explore All Our Tools</h2>
                        <p>Our team creates useful tools for web designers</p>
                        <p>Discover a collection of powerful and easy-to-use tools designed to boost your creativity and productivity. From SVG generators to color utilities, responsive testing, and code examples, thedc.tech brings you everything in one place. Browse, create, and enhance your projects effortlessly with our curated tools.</p>

                    </div>
                </div>


                <div className='__abouts mt-0 p-0'>
                    <div className='__container'>
                        <div className='__Lists'>
                            <div className='row justify-content-center row-gap-5'>
                                {
                                    TopItem.map((val, index) => (
                                        <div className='col-md-3 col-6' key={index}>
                                            <div className='__item'>
                                                <Link to={val.link}>
                                                    <div className='__icon'>
                                                        {val.icon}
                                                    </div>

                                                    <div className='__txt'>
                                                        <h5 className='color-txt'> {val.name}</h5>
                                                        <p> {val.pragraph}</p>
                                                    </div>

                                                    <p className='__viewApp'><OpenInNew /></p>
                                                </Link>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>

                </div>


                <div className='__container information'>
                    <p> Created by <Link to={linkedinLink} title='linkdin' target='_blank'>@sunilsharma</Link> or <Link title='Instagram' to={instaLink} target='_blank'>@tᖾᥱᑯᥴ_</Link></p>
                </div>

            </div>

        </>
    );
}

export default PreviewTools;
